define('requestAnimationFrame',['modernizr'],function(){

    // Modernizr Polyfill for requestAnimationFrame

    var requestAnimationFrame = Modernizr.prefixed('requestAnimationFrame', window);
    if(!window.requestAnimationFrame){
        window.requestAnimationFrame = requestAnimationFrame;
    }
    var cancelAnimationFrame = Modernizr.prefixed('cancelAnimationFrame', window);
    if(!window.cancelAnimationFrame){
        window.cancelAnimationFrame = cancelAnimationFrame;
    }
    return requestAnimationFrame;
});
